import { useAppStore } from "./../stores/app-store";
import FormBonusEco from "../components/form-bonus-eco";
import FormBonusMobili from "../components/form-bonus-mobili";
import { AVAILABLE_BONUSES } from "../types";

const BONUS_FORMS = {
  1: FormBonusEco,
  2: FormBonusMobili,
};

export const isMediaWorld = () => {
  return process.env.REACT_APP_IS_MEDIAWORLD;
};

export const useFormPratica = (bonus?: AVAILABLE_BONUSES) => {
  const activeBonus = useAppStore((state) => state.activeBonus);

  return BONUS_FORMS[bonus ? bonus : activeBonus];
};
